// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-pro-multifunction-shoulder-messenger-bag-fit-for-14-1-or-17-3-laptop",
  "entries": [
    {
      "id": "24117080850622",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-24117080850622.jpg?v=1769483194",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop"
    },
    {
      "id": "31065504383166",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-31065504383166.png?v=1769483194",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "31065505038526",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-31065505038526.png?v=1769483194",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033341118",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033341118.jpg?v=1769483194",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033242814",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033242814.jpg?v=1769483194",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033799870",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033799870.jpg?v=1769483194",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033865406",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033865406.jpg?v=1769483194",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033373886",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/91saGmiVkUL._AC_SL1500.jpg?v=1763362251",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033210046",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033210046.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033668798",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033668798.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033767102",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033767102.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033570494",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033570494.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749032980670",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749032980670.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033111742",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033111742.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749032849598",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749032849598.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033898174",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033898174.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033603262",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033603262.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "31065504743614",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-31065504743614.png?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "31065505497278",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-31065505497278.png?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033406654",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033406654.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033930942",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033930942.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033734334",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033734334.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749034029246",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749034029246.jpg?v=1769483200",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033439422",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033439422.jpg?v=1769483212",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749032784062",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749032784062.jpg?v=1769483212",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033177278",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749033177278.jpg?v=1769483212",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "24117081800894",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-24117081800894.jpg?v=1769483212",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop"
    },
    {
      "id": "24135291076798",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-24135291076798.jpg?v=1769483212",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop"
    },
    {
      "id": "24135294681278",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-24135294681278.jpg?v=1769483212",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop"
    },
    {
      "id": "28749032816830",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Pro-Multifunction-Shoulder-Messenger-Bag-Fit-for-14-1-or-17-3-Laptop-Seibertron-28749032816830.jpg?v=1769483212",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop - Seibertron"
    },
    {
      "id": "28749033144510",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/71RF70NLP_L._AC_SL1500.jpg?v=1763362251",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop"
    },
    {
      "id": "28749033963710",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/818cg4S9BXL._AC_SL1500.jpg?v=1763362251",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop"
    },
    {
      "id": "28749033996478",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/81GVy3pWV8L._AC_SL1500.jpg?v=1763362251",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop"
    },
    {
      "id": "28749033701566",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/81Zz9o7Xc3L._AC_SL1500__1.jpg?v=1763362251",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop"
    },
    {
      "id": "28749034062014",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/91PyBnFtZ4L._AC_SL1500.jpg?v=1763362251",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop"
    },
    {
      "id": "28749032882366",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/61oYIzBQZJL._AC_SL1188__3.jpg?v=1763362251",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop"
    },
    {
      "id": "28749033308350",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/71RF70NLP_L._AC_SL1500__1.jpg?v=1763362251",
      "alt": "Seibertron Pro-Multifunction Shoulder Messenger Bag Fit for 14.1\" or 17.3\" Laptop"
    }
  ],
  "variants": [
    {
      "id": "41897905815742",
      "title": "Fit 17.3\" Laptop Black",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fit 17.3\" Laptop Black"
        }
      ],
      "values": [
        "Fit 17.3\" Laptop Black"
      ],
      "mediaId": "24117080850622"
    },
    {
      "id": "41897905848510",
      "title": "Fit 17.3\" Laptop Khaki",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fit 17.3\" Laptop Khaki"
        }
      ],
      "values": [
        "Fit 17.3\" Laptop Khaki"
      ],
      "mediaId": "31065504743614"
    },
    {
      "id": "41897905881278",
      "title": "Fit 14.1\" Laptop Black",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fit 14.1\" Laptop Black"
        }
      ],
      "values": [
        "Fit 14.1\" Laptop Black"
      ],
      "mediaId": "31065505038526"
    },
    {
      "id": "41897905914046",
      "title": "Fit 14.1\" Laptop Khaki",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fit 14.1\" Laptop Khaki"
        }
      ],
      "values": [
        "Fit 14.1\" Laptop Khaki"
      ],
      "mediaId": "31065505497278"
    },
    {
      "id": "41974779445438",
      "title": "1 piece of luggage strap black",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "1 piece of luggage strap black"
        }
      ],
      "values": [
        "1 piece of luggage strap black"
      ],
      "mediaId": "24135291076798"
    },
    {
      "id": "41974779478206",
      "title": "1 piece of luggage strap khaki",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "1 piece of luggage strap khaki"
        }
      ],
      "values": [
        "1 piece of luggage strap khaki"
      ],
      "mediaId": "24135294681278"
    }
  ],
  "singleVariant": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var mediaIds = config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
})();
// END motorbikeBackpackGalleryRestore20260716
